// 专门处理一些银行特色要求的样式  比如中信OTA
import { getAgentId } from '@/utils/getValue';

const getSpecialClassName = () => {
  const agentId = getAgentId();
  const citicOTAAgentIds = ['12002'];
  if (citicOTAAgentIds.includes(agentId)) {
    return 'citicOTA';
  }
  return '';
};

export default getSpecialClassName;
